/* src/app/pages/amplify-auth/user-sign-in/user-sign-in.component.scss */
.mat-mdc-form-field {
  display: block;
}
/*# sourceMappingURL=user-sign-in.component.css.map */
